var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"da-ui--button",class:['da-ui--button_' + _vm.type],on:{"click":_vm.click}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }